import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppErrorBoundary } from '@/components/AppErrorBoundary';
import { rememberPdfDebugFromLocation } from '@/utils/pdfSelectionDebug';
import './lib/i18n';
import './styles/fonts.css';
import './index.css';
import './styles/design-v2.css';
import './styles/lab-results.css';
import './styles/forloeb.css';
import './styles/skemaer.css';
import './styles/send.css';
import './styles/portal.css';

rememberPdfDebugFromLocation();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found');

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
